/**
 * @fileoverview Custom element for handling modal dialogs
 */
class DetailsModal extends HTMLElement {
  /**
   * Creates a new DetailsModal instance
   * Sets up event listeners and accessibility attributes
   */
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    this.querySelectorAll('button[type="button"]').forEach((e) => {
      e.addEventListener('click', this.close.bind(this));
    });

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  /**
   * Checks if the modal is currently open
   * @returns {boolean} True if modal is open
   */
  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  /**
   * Handles summary click event
   * @param {Event} event - The click event
   */
  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  /**
   * Handles body click event to close modal
   * @param {Event} event - The click event
   */
  onBodyClick(event) {
    if (
      document
        .querySelector('header')
        .classList.contains('search-header--opened')
    ) {
      return;
    }
    if (!this.contains(event.target)) this.close(false);
  }

  /**
   * Opens the modal
   * @param {Event} event - The event that triggered the open
   */
  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  /**
   * Closes the modal
   * @param {boolean} focusToggle - Whether to focus the toggle element
   */
  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('search-overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
